import { withNamespaces } from 'react-i18next';
import { Nav, NavItem, NavLink } from 'reactstrap';

import { FreightTabs } from '../constants';

const Tabs = ({
    t,
    activeTab,
    counts = {},
    onChange,
}) => {
    return (
        <Nav tabs className="nav-tabs-custom">
            {FreightTabs.map((tab) => {
                const isActive = tab.key === activeTab;

                return (
                    <NavItem className={isActive ? 'active' : ''} key={tab.key}>
                        <NavLink
                            className={isActive ? 'active' : ''}
                            onClick={() => onChange(tab.key)}
                            style={{ cursor: 'pointer' }}
                        >
                            {`${t(tab.title)} (${counts[tab.key] || 0})`}
                        </NavLink>
                    </NavItem>
                );
            })}
        </Nav>
    );
};

export default withNamespaces()(
    Tabs
);
